import React, { useEffect, useState } from 'react';

const PainOrdersTable = (props) => {
  const [paintOrders, setPaintOrders] = useState([]);

  useEffect(() => {
    setPaintOrders(props.paintOrders);
  }, [props.paintOrders]);

  /**
   * Generates the table with the receipts on it
   * @param {*} receipts
   * @returns
   */
  const generateTable = (orders) => {
    const headers = orders ? Object.keys(orders[0]).filter((key) => key !== 'user') : null;
    headers.push('actions');

    const generateHeaders = (headers) => {
      const HEADER_MAPS = {
        date: 'Fecha',
        paintType: 'Tipo de Pintura',
        liters: 'Litros',
        orderNumber: 'Num. Orden',
        observations: 'Observaciones',
        status: 'Estado',
        actions: 'Acciones',
      };

      const tableHeaders = [];
      if (headers) {
        for (let i = 0; i < headers.length; i++) {
          tableHeaders.push(
            <th className="text-center" key={`col-he-${i}`} scope="col">
              {HEADER_MAPS[headers[i]]}
            </th>
          );
        }
      }
      return tableHeaders;
    };

    const deleteItem = (index) => {
      props.delete(index);
    };

    const generateRowData = (order) => {
      const data = [];
      const keys = Object.keys(order).filter((key) => key !== 'user');
      keys.push('actions');

      keys.forEach((key, index) => {
        let value = order[key];
        if (key === 'date') {
          value = value.split('T')[0];
        }

        if (key === 'actions') {
          data.push(
            <td
              className="row-clickeable text-center"
              key={`${index}-${value}-actions`}
            >
              <i className="material-icons icon-action icon-md-18">delete</i>
            </td>
          );
        } else {
          data.push(<td key={`${index}-${value}`}>{value}</td>);
        }
      });

      return data;
    };

    const generateRows = (orders) => {
      const productItems = [];
      if (orders) {
        for (let i = 0; i < orders.length; i++) {
          productItems.push(
            <tr
              className="row-clickeable"
              key={`row-${i}`}
              onClick={() => deleteItem(i)}
            >
              {generateRowData(orders[i])}
            </tr>
          );
        }
      }
      return productItems;
    };

    return (
      <>
        <table
          className="table table-sm table-responsive table-hover table-bordered table-custom"
          style={{ maxWidth: '1140px' }}
        >
          <thead className="thead-light">
            <tr>{generateHeaders(headers)}</tr>
          </thead>
          <tbody>{generateRows(orders)}</tbody>
        </table>
      </>
    );
  };

  return (
    <div className="receipts-table">
      {paintOrders.length > 0 && generateTable(paintOrders)}
    </div>
  );
};

export default PainOrdersTable;
